<template>
  <div class="koyoukeiyaku-detail">
    <div class="detail">
      <loading v-if="!isInit" :message="'データ読み込み中...'"></loading>
      <p v-else-if="isInit && !keiyakuDetail" class="align-center">この雇用契約は存在しないか閲覧権限がありません</p>
      <template v-else-if="isInit && options && keiyakuDetail">

        <h3 class="title">
          <span class="deleted" v-if="keiyakuDetail.is_sakujo">※削除済み※<br></span>
          <span class="changed" v-else-if="keiyakuDetail.is_changed">※変更済み※<br></span>
          {{ keiyakuDetail.name }}さん / 雇用契約書ID:{{ keiyakuDetail.koyou_keiyaku_id }}
        </h3>

        <div class="buttons">
          <!-- 差し戻されたり削除済みの契約書を元にする可能性もあるので制限は設けない -->
          <button v-if="authStore.hasPermission(PermissionConst.KOYOUKEIYAKU_CREATE)" class="btn primary"
            v-on:click="createFrom()">
            この契約書を元に新規作成
          </button>

          <!--
            本人承認済み　かつ　未削除
            特に明示書は内容変更時に複製処理を行うため本人承認前（＝複製される前）に新規作成されると
            上書き確認の新規実装が必要になることや複製元があることを知らずに作成されることを防ぐためこの条件とする
          -->
          <template v-if="
            keiyakuDetail.honnin_status_type === OptionConst.SELF_TYPE_APPROVED &&
            keiyakuDetail.is_sakujo === false
          ">
            <button class="btn primary" v-on:click="download(keiyakuDetail!.koyou_keiyaku_id)">ダウンロード</button>
            <button class="btn primary"
              @click="$router.push({ name: RouterConst.MEIJISYO_DETAIL,
                params: {
                  id: keiyakuDetail!.koyou_keiyaku_id,
                } })">就業条件明示書の作成・編集</button>
            <button class="btn primary"
              @click="$router.push({
                name: RouterConst.KOYOUKEIYAKU_MODIFY,
                params: {
                  id: keiyakuDetail!.koyou_keiyaku_id,
                }, })">修正</button>
          </template>

          <!-- 提出前　かつ　未削除 -->
          <template v-if="
            keiyakuDetail.submitted_date === null &&
            keiyakuDetail.is_sakujo === false
          ">
            <button class="btn primary" v-on:click="edit()">編集する</button>
            <button class="btn primary" v-on:click="submitOn()">提出する</button>
          </template>


          <!-- 削除または取り下げボタン -->
          <template v-if="canDelete">
            <button v-if="keiyakuDetail.syounin_status_type !== OptionConst.SYOUNIN_STATUS.WAIT" class="btn danger" v-on:click="deleteKoyouKeiyaku()">削除する</button>
            <button v-else-if="keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT" class="btn warning" v-on:click="doApproval(OptionConst.SYOUNIN_STATUS.CANCEL)">取り下げる</button>
          </template>
        </div>

        <template v-if="syouninFlow.length <= 0">
          <p v-show="keiyakuDetail.syounin_status_type !== null">承認フローデータが取得できませんでした。</p>
        </template>

        <template v-else-if="
          keiyakuDetail.syounin_status_type !== OptionConst.SYOUNIN_STATUS.CANCEL &&
          syouninFlow.length > 0
        ">
          <h3>承認操作</h3>

          <!-- 否認（不採用 or 差し戻し）された場合 && お知らせが既読になっていない場合、提出者にその後の処理を促す -->
          <div class="read-denied-message" v-if="
            (
              authStore.isAdmin ||
              authStore.user?.user_id === keiyakuDetail.eigyou_user_id)
            &&
            (
              keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED ||
              keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.REMAND
            )
            && keiyakuDetail.readedDeniedMessage === false
          ">
            <p>雇用契約が否認されました。コメントを確認してください。</p>
            <div class="buttons">
              <button class="btn success" v-on:click="readMessage()">否認理由を確認しました</button>
            </div>
          </div>

          <!-- 承認状況 -->
          <table class="route-list syanai">
            <tr>
              <th class="head" :rowspan="syouninFlow.length + 1">社内承認状況</th>
              <th class="order">順序</th>
              <th class="user">承認者</th>
              <th class="syanai-status">承認状況</th>
              <th class="notes">コメント</th>
            </tr>
            <tr v-for="(flow, index) in syouninFlow" :key="index" :class="
              {
                'denied': flow.status_type === OptionConst.SYOUNIN_STATUS.DENIED ||
                  flow.status_type === OptionConst.SYOUNIN_STATUS.REMAND
              }
            ">
              <td class="order" v-if="flow.syounin_order">{{ flow.syounin_order }}</td>
              <td class="user" v-else>確認者</td>
              <td class="user">{{ flow.staff_name }}</td>
              <td class="syanai-status" v-if="
                (
                  flow.user_id === loginUserId ||
                  authStore.isAdmin
                )
                &&
                flow.is_next && flow.is_syounin
              ">
                <div class="buttons">
                  <button v-on:click="doApproval(OptionConst.SYOUNIN_STATUS.APPROVED)">承認<i
                      class="fa-solid fa-pen btn-edit"></i></button>
                  <button v-on:click="doApproval(OptionConst.SYOUNIN_STATUS.DENIED)">不採用<i
                      class="fa-solid fa-pen btn-edit"></i></button>
                  <button v-on:click="doApproval(OptionConst.SYOUNIN_STATUS.REMAND)">差し戻し<i
                      class="fa-solid fa-pen btn-edit"></i></button>
                </div>
              </td>

              <!-- TODO:開発用に誰でも確認できる状態 -->
              <td v-else-if="
                (
                  flow.user_id === loginUserId ||
                  authStore.isAdmin
                )
                &&
                !flow.syounin_order &&
                flow.status_type === OptionConst.SYOUNIN_STATUS.WAIT &&
                keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED
              ">
                <button v-on:click="doCheck()">確認済にする<i class="fa-solid fa-pen btn-edit"></i></button>
              </td>

              <td v-else class="syanai-status result">
                <p v-if="
                  (
                    keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED ||
                    keiyakuDetail.syounin_status_type === OptionConst.SYOUNIN_STATUS.REMAND
                  ) &&
                  flow.status_type === OptionConst.SYOUNIN_STATUS.WAIT
                ">
                  ---</p>
                <p v-else-if="flow.syounin_order">
                  {{ getOptionsLabel(options.syounin_status_type, flow.status_type) }}
                </p>
                <p v-else-if="!flow.syounin_order && flow.status_type === OptionConst.SYOUNIN_STATUS.WAIT">確認待ち</p>
                <p v-else-if="!flow.syounin_order && flow.status_type === OptionConst.SYOUNIN_STATUS.APPROVED">確認済</p>
              </td>
              <td class="notes">{{ flow.status_notes }}</td>
            </tr>
          </table>

          <!-- 本人承認状況 -->
          <table v-if="canHonninSyounin" class="route-list honnin">
            <tr>
              <th class="head" rowspan="2">本人承認状況</th>
              <th class="honnin-status">承認状況</th>
              <th class="control">操作</th>
            </tr>
            <tr>
              <td class="honnin-status">
                <div class="options">
                  <input-radio :options="options.honnin_status_type" v-model="honninStatusType"
                    :disabled="keiyakuDetail.is_sakujo || keiyakuDetail.honnin_status_type === OptionConst.SELF_TYPE_APPROVED" ></input-radio>
                </div>
                <p class="danger-text align-center" v-if="keiyakuDetail.honnin_status_type === OptionConst.SELF_TYPE_APPROVED">本人了承済みの場合は変更できません。</p>

              </td>
              <td class="control">
                <button :disabled="!honninStatusType || keiyakuDetail.is_sakujo || keiyakuDetail.honnin_status_type === OptionConst.SELF_TYPE_APPROVED" v-on:click="doHonninSyounin()">更新する<i
                    class="fa-solid fa-pen btn-edit"></i></button>
              </td>
            </tr>
          </table>
        </template>

        <!-- 提出済み -->
        <template v-if="keiyakuDetail.syounin_status_type !== null">
          <h3>承認状況</h3>
          <div class="row">

            <div class="detail-item">
              <div class="head"><b>提出者</b></div>
              <div class="data">
                <p>{{ keiyakuDetail.submitted_user_name ? keiyakuDetail.submitted_user_name : undefinedLabel }}</p>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="detail-item">
              <div class="head"><b>提出日</b></div>
              <div class="data">
                <p>{{ keiyakuDetail.submitted_date ? keiyakuDetail.submitted_date : undefinedLabel }}</p>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="detail-item">
              <div class="head"><b>社内承認</b></div>
              <div class="data">
                <p>{{ getOptionsLabel(options.syounin_status_type, keiyakuDetail.syounin_status_type) }}</p>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="detail-item">
              <div class="head"><b>本人承認</b></div>
              <div class="data">
                <p>{{ getOptionsLabel(options.honnin_status_type, keiyakuDetail.honnin_status_type) }}</p>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="detail-item">
              <!-- <template v-if="keiyakuDetail.value.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED || keiyakuDetail.value.syounin_status_type === 9 || keiyakuDetail.value.honnin_status_type === OptionConst.SYOUNIN_STATUS.REMAND"> -->
              <div class="head"><b>不採用理由</b></div>
              <div class="data">
                <p class="pre">{{ keiyakuDetail.fusaiyou_notes }}</p>
              </div>
            </div>
          </div>
        </template>

        <h3>契約内容</h3>
        <!-- 所属 -->
        <div class="row">
          <syozoku-detail :editingData="keiyakuDetail" :options="options"></syozoku-detail>
        </div>

        <div class="row">
          <shinsei-type-detail :editingData="keiyakuDetail" :options="options"></shinsei-type-detail>
          <koyou-type-detail :editingData="keiyakuDetail" :options="options"></koyou-type-detail>
          <keitai-type-detail :editingData="keiyakuDetail" :options="options"></keitai-type-detail>
        </div>

        <div class="row">
          <keiyaku-koushin-type-detail :editingData="keiyakuDetail" :options="options"></keiyaku-koushin-type-detail>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>氏名（フリガナ）</b></div>
            <div class="data">
              <p>
                {{ keiyakuDetail.name ? keiyakuDetail.name : undefinedLabel }}
                （{{ keiyakuDetail.kana ? keiyakuDetail.kana : undefinedLabel }}）
              </p>
            </div>
          </div>
        </div>

        <!-- 入社、入替の場合、現行のExcelには社員番号の記載欄が無い為、shinsei_typeの分岐で非表示を切り分け -->
        <div class="row" v-if="
          keiyakuDetail.shinsei_type !== OptionConst.KOYOU_SHINSEI_TYPE.ENTRY &&
          keiyakuDetail.shinsei_type !== OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY
        ">
          <div class="detail-item">
            <div class="head"><b>社員番号</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.staff_code ? keiyakuDetail.staff_code : undefinedLabel }}</p>
            </div>
          </div>
        </div>

        <div class="row" v-if="
          keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE ||
          keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY
        ">
          <div class="detail-item">
            <div class="head"><b>入替社員氏名</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.change_user_name ? keiyakuDetail.change_user_name : undefinedLabel }}</p>
            </div>
            <div class="head"><b>引継期間終了日</b></div>
            <div class="data">
              <p v-if="keiyakuDetail.hikitsugi_end_date != null">{{ keiyakuDetail.hikitsugi_end_date }}まで</p>
            </div>
          </div>
        </div>

        <div class="row">
          <nyuusya-date-detail :editingData="keiyakuDetail"></nyuusya-date-detail>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>雇用期間</b></div>
            <div class="data">

              <template v-if="keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI
                || keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI">
                <p>{{ keiyakuDetail.keiyaku_date ? keiyakuDetail.keiyaku_date : undefinedLabel }}〜{{ OptionConst.KOYOU_KEIYAKU_MUKI_LABEL }}</p>
              </template>

              <template v-else>
                <p>
                  {{ keiyakuDetail.keiyaku_date ? keiyakuDetail.keiyaku_date : undefinedLabel }}〜{{
                    keiyakuDetail.koyou_end_date ? keiyakuDetail.koyou_end_date : undefinedLabel }}</p>
              </template>
            </div>
          </div>
        </div>

        <template v-if="keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE">
          <div class="row">

            <div class="detail-item">
              <div class="head"><b>変更日</b></div>
              <p>{{ keiyakuDetail.keiyaku_date ? keiyakuDetail.keiyaku_date : undefinedLabel }}</p>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>請求開始予定月日</b></div>
            <p>{{ keiyakuDetail.seikyu_start_date ? keiyakuDetail.seikyu_start_date : undefinedLabel }}</p>
          </div>
        </div>

        <div class="row" v-if="keiyakuDetail.syozoku_id === OptionConst.SYOZOKU.PG">
          <div class="detail-item">
            <div class="head"><b>協定対象派遣</b></div>
            <template v-if="keiyakuDetail.is_kyoutei === false">
              <p>協定対象派遣労働者ではない</p>
            </template>

            <template v-else-if="keiyakuDetail.is_kyoutei === true">
              <p>協定対象派遣労働者である</p>
              <div class="head"><b>当該協定の有効期間の終了日</b></div>
              <p>{{ keiyakuDetail.kyoutei_end_date ? keiyakuDetail.kyoutei_end_date : undefinedLabel }}</p>
            </template>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>部課・就業場所</b></div>
            <div class="data" v-if="keiyakuDetail.syuugyou_basyos">
              <b>部課（PX上の管理区分）</b>
              <p>{{ getOptionsLabel(allBukaOptions, keiyakuDetail.syuugyou_basyos.mst_buka_id) }}
              </p>

              <b>就業場所</b>
              <p>{{ keiyakuDetail.syuugyou_basyos.syuugyou_basyo_name ?
                keiyakuDetail.syuugyou_basyos.syuugyou_basyo_name : undefinedLabel }}
              </p>
              <p v-if="keiyakuDetail.syuugyou_basyos.syuugyou_basyo_address">
                {{ keiyakuDetail.syuugyou_basyos.syuugyou_basyo_address }}
              </p>
              <p v-if="keiyakuDetail.syuugyou_basyos.syuugyou_basyo_address">
                {{ keiyakuDetail.syuugyou_basyos.syuugyou_basyo_tel }}
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>業務内容</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.work_detail1 }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>業務内容（詳細）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.work_detail2 }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="work-times detail-item">
            <div class="head"><b>就業時間</b></div>
            <div class="data">
              <template v-if="keiyakuDetail.work_times === null || keiyakuDetail.work_times.length < 1">
                <p>無し</p>
              </template>

              <template v-else>
                <div class="work-time" v-for="(item, index) in keiyakuDetail.work_times" :key="index">
                  <div class="head"><b>就業時間{{ (index + 1) }}</b></div>

                  <div class="day">
                    <div class="item flex flex-align-center">
                      <p class="head">曜日：</p>
                      <p>{{ getYoubiLabel(item).join('・') }}</p>
                      <p v-if="item.weeks">/ 第{{ item.weeks.join('・') }}</p>
                    </div>
                  </div>

                  <div class="time">
                    <div class="item flex">
                      <p class="head">開始〜終了：</p>
                      <p>{{ timeToHHmm(item.start_time) }} 〜 {{ timeToHHmm(item.end_time) }}</p>
                    </div>

                    <div class="item flex">
                      <p class="head">通常勤務時間：</p>
                      <p>{{ timeToHHmm(item.tsuujou_times) }}</p>
                    </div>

                    <div class="item flex">
                      <p class="head">休憩時間：</p>
                      <p>{{ timeToHHmm(item.kyuukei_times) }}</p>
                    </div>
                  </div>

                  <div class="kyuujitsu">
                    <div class="item flex">
                      <p class="head">半日勤務：</p>
                      <template v-if="item.is_hannichi === false">
                        <p>無</p>
                      </template>
                      <template v-else-if="item.is_hannichi === true">
                        <p>有</p>
                      </template>
                    </div>
                    <div class="item flex">
                      <p v-if="!item.is_hannichi && !item.can_only_am_kinmu && !item.can_only_pm_kinmu">※ {{ OptionConst.KYUUJISU_SYUTOKU_TYPE_OPTIONS[0]?.label }}</p>
                      <p v-if="item.can_only_am_kinmu">※ {{ OptionConst.KINMU_TYPE_OPTIONS.find(v => v.val === (item.can_only_am_kinmu ? OptionConst.KINMU_TYPE.AM_KINMU : 0))?.label }}</p>
                      <p v-if="item.can_only_pm_kinmu">※ {{ OptionConst.KINMU_TYPE_OPTIONS.find(v => v.val === (item.can_only_pm_kinmu ? OptionConst.KINMU_TYPE.PM_KINMU : 0))?.label }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>有給取得時の<br>差し引き時間</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.sashihiki_times_hours }}時間{{ keiyakuDetail.sashihiki_times_minutes }}分</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>休日</b></div>
            <p class="pre">{{ message.HOLIDAY }}</p>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>備考</b></div>
            <p class="pre">{{ keiyakuDetail.kyujitsu_zougen_notes }}</p>
          </div>
        </div>

        <div class="row">

          <div class="detail-item">
            <div class="head"><b>時間外及び休日労働</b></div>
            <div class="data">
              <template v-if="keiyakuDetail.is_jikangai">
                <p class="pre" v-if="keiyakuDetail.syozoku_id === OptionConst.SYOZOKU.PM">
                  {{ message.WITHOUT_WORKTIME_PM }}</p>
                <p class="pre" v-if="keiyakuDetail.syozoku_id === OptionConst.SYOZOKU.PG">
                  {{ message.WITHOUT_WORKTIME_PG }}</p>
              </template>
              <p v-if="!keiyakuDetail.is_jikangai">無</p>
            </div>
          </div>
        </div>

        <!-- 現状は、時間外及び休日労働がfalseの場合も、「時間外手当の考え（伺い書のみで、不要項目かはお客様確認中のため）」は編集可能としている為、表示 -->
        <div class="row">
          <div class="detail-item">
            <div class="head"><b>時間外手当の考え</b></div>
            <div class="data">
              <p class="pre">{{ keiyakuDetail.jikangai_notes }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>所定労働日数（週）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.syotei_work_week_days }}日</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>所定労働時間（週）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.syotei_work_week_times_hours }}時間{{ keiyakuDetail.syotei_work_week_times_minutes }}分
              </p>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="detail-item">
            <div class="head"><b>所定労働時間（月）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.syotei_work_month_times }}時間</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>包括時間</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.houkatsu_times_hours }}時間{{ keiyakuDetail.houkatsu_times_minutes }}分</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>労災保険</b></div>
            <div class="data">
              <p>有</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>雇用保険</b></div>
            <div class="data">
              <p v-if="keiyakuDetail.is_koyou_hoken">有</p>
              <p v-else>無</p>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="detail-item">
            <div class="head"><b>社会保険</b></div>
            <div class="data">
              <p v-if="keiyakuDetail.is_syakai_hoken">有</p>
              <p v-else>無</p>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="detail-item">
            <div class="head"><b>年次有給休暇</b></div>
            <div class="data">
              <!-- 【有給日数】月給、月給無期、時給の場合 -->
              <template v-if="keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU
                || keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI
                || keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.JIKYUU">
                <p>6ヶ月間継続勤務し、引き続き勤務する場合、年{{ keiyakuDetail.yuukyuu_days }}日
                </p>
                <p class="pre">{{ message.NENNJI_YUUKYUU }}</p>
              </template>

              <!-- 【年次有給休暇】パート、パート無期の場合 -->
              <p v-else-if="
                keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.PART ||
                keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI" class="pre">
                {{ message.NENNJI_YUUKYUU_PART }}
              </p>

              <!-- 【計画有給】月給、月給無期の場合 -->
              <p v-if="
                keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU ||
                keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI" class="pre">
                {{ message.KEIKAKU_YUUKYUU }}
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>締め日</b></div>

            <div class="data">
              <template v-if="keiyakuDetail.shime_day === 31">
                <p>月末締め</p>
              </template>
              <template v-else>
                <p>{{ keiyakuDetail.shime_day }}日締め</p>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>支払い日</b></div>

            <div class="data">
              <p>翌月</p>
              <p>{{ keiyakuDetail.pay_day ? keiyakuDetail.pay_day : OptionConst.PAY_DAY }}日</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head">
              <b v-if="keiyakuDetail.is_jikyuu">時給</b>
              <b v-else>基本給</b>
            </div>

            <div class="data">
              <p>{{ numberFormat(keiyakuDetail.kihonkyuu) }}円</p>
            </div>
          </div>
        </div>

        <!-- PG時給タイプの月給換算（PG雇入れ連絡票用のための参考表示） -->
        <div class="row" v-if="keiyakuDetail.is_jikyuu">
          <jikyuu-calc-detail :editingData="keiyakuDetail"></jikyuu-calc-detail>
        </div>

        <div class="row" v-if="!keiyakuDetail.is_jikyuu">
          <div class="detail-item">
            <div class="head"><b>手当</b></div>
            <div class="data">
              <template v-if="keiyakuDetail.teates === null || keiyakuDetail.teates?.length < 1">
                <p>無し</p>
              </template>

              <template v-else>
                <p v-for="item in keiyakuDetail.teates">
                  {{ getOptionsLabel(options.teate, item.mst_teate_id) }}：{{ numberFormat(item.kingaku) }}円</p>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>通勤手当</b></div>
            <div class="data">
              <p>非課税：{{ numberFormat(keiyakuDetail.koutsuuhi) }}円 ／ 課税：{{
                numberFormat(keiyakuDetail.koutsuuhi_kazei) }}円</p>
              <p>{{ message.CARFARE }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>残業（見込み）</b></div>
            <div class="data">
              <p>{{ numberFormat(keiyakuDetail.zangyou_mikomi) }}円</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>賃金合計</b></div>
            <div class="data">
              <template v-if="isNaN(calcSalary(keiyakuDetail))">
                <p>算出不可</p>s
              </template>
              <template v-else>
                <p>{{ numberFormat(calcSalary(keiyakuDetail)) }}円</p>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>昇給・賞与</b></div>
            <div class="data">
              <p>昇給：
                <span v-if="keiyakuDetail.is_syoukyuu">有（業績・評価による）</span>
                <span v-else>無</span>
              </p>
              <p>賞与：
                <span v-if="keiyakuDetail.is_syouyo">有</span>
                <span v-else>無</span>
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>退職金</b></div>
            <div class="data">
              <p v-if="keiyakuDetail.is_taisyokukin">有（勤続3年以上の場合に支給）</p>
              <p v-else>無</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>自己都合退職</b></div>

            <div class="data">
              <p class="pre">{{ message.RETIREMENT_SELF }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>定年</b></div>
            <div class="data">
              <p class="pre">{{ message.RETIREMENT_AGE }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>解雇</b></div>
            <div class="data">
              <p class="pre">{{ message.DISMISS }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>その他</b></div>
            <div class="data">
              <!-- パート、パート無期の場合は相談窓口を表示 -->
              <template
                v-if="keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.PART || keiyakuDetail.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI">
                <p class="pre" v-show="keiyakuDetail.syozoku_id === OptionConst.SYOZOKU.PM">{{ message.OTHER_COUNTER_PM
                }}</p>
                <p class="pre" v-show="keiyakuDetail.syozoku_id === OptionConst.SYOZOKU.PG">{{ message.OTHER_COUNTER_PG
                }}</p>
              </template>
              <template v-else>
                <p class="pre">{{ message.OTHER }}</p>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>更新の有無</b></div>

            <div class="data">
              <template v-if="keiyakuDetail.is_keiyaku_koushin === 1">
                <p>有</p>
                <p class="pre">{{ message.UPDATE_TRUE }}</p>
              </template>
              <template v-else-if="keiyakuDetail.is_keiyaku_koushin === 0">
                <p>無</p>
                <p class="pre">{{ message.UPDATE_NONE }}</p>
              </template>
              <template v-else-if="keiyakuDetail.is_keiyaku_koushin === null">
                <p class="pre">{{ message.UPDATE_UNSELECTED }}</p>
              </template>
            </div>
          </div>
        </div>

        <div class="row old-koyou-keiyakus" v-if="
          keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
          keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE
        ">
          <div class="detail-item">
            <div class="head"><b>内容変更対象の<br>雇用契約書</b></div>
            <div class="data">
              <div v-if="keiyakuDetail.old_koyou_keiyakus.length < 1">
                <p>無し</p>
              </div>
              <div v-else>
                <ul>
                  <li :class="{ 'main': item.is_main }" v-for="item in keiyakuDetail.old_koyou_keiyakus">雇用契約ID:{{
                    item.old_koyou_keiyaku_id }}<span v-if="item.is_main">（主）</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 変更対象の雇用契約がある場合のみ -->
        <div class="row" v-if="
          keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
          (keiyakuDetail.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE && keiyakuDetail.old_koyou_keiyakus?.length)
        ">
          <div class="detail-item">
            <div class="head"><b>本人通知欄<br>（変更内容）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.honnin_notes }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>社内メモ欄<br>（備考、変更理由等）</b></div>
            <div class="data">
              <p class="pre">{{ keiyakuDetail.syanai_notes }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>担当営業者</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.eigyou_user_name ? keiyakuDetail.eigyou_user_name : undefinedLabel }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="detail-item">
            <div class="head"><b>添付ファイル</b></div>
            <div class="data">
              <koyoukeiyaku-files v-if="keiyakuDetail.tenpufiles && keiyakuDetail.tenpufiles.length > 0"
                :tenpufiles="keiyakuDetail.tenpufiles"></koyoukeiyaku-files>
              <p v-else>登録されていません</p>
            </div>
          </div>
        </div>

        <h3>管理情報</h3>
        <div class="row">
          <div class="detail-item">
            <div class="head"><b>雇用契約書合計<br>（同期間内）</b></div>
            <div class="data">
              <p>{{ keiyakuDetail.counts ? keiyakuDetail.counts : 0 }}枚</p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>


<script lang="ts">
import { computed, defineComponent, ref, onMounted, Ref } from 'vue';
import Message from "@/const/KoyouKeiyaku/Message";
import { usePrint } from '@/composable/koyoukeiyaku/pdfdownload';
import { useRouter } from 'vue-router'
import { RouterConst } from '@/const/Router';
import { useApproval } from '@/composable/koyoukeiyaku/detail/approval';
import { useAuthStore } from '@/store/auth';
import { useDelete } from '@/composable/koyoukeiyaku/detail/delete';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import { cloneDeep } from 'lodash';
import { useKoyouKeiyakuDetail } from '@/composable/koyoukeiyaku/detail';
import OptionConst from '@/const/Option';
import { useMstBukaInit } from '@/composable/buka/init';
import { DialogService } from "@/service/DialogService";
import { SweetAlertResult } from 'sweetalert2';
import { PermissionConst } from '@/const/Permission';
import { useFileDownload } from '@/composable/common/file-download';
import KoyouKeiyakuFiles from '@/components/koyoukeiyaku/parts/KoyouKeiyakuFiles.vue'
import ShinseiTypeDetail from '@/components/koyoukeiyaku/parts/ShinseiTypeDetail.vue'
import KoyouTypeDetail from '@/components/koyoukeiyaku/parts/KoyouTypeDetail.vue'
import KeitaiTypeDetail from '@/components/koyoukeiyaku/parts/KeitaiTypeDetail.vue'
import KeiyakuKoushinTypeDetail from '@/components/koyoukeiyaku/parts/KeiyakuKoushinTypeDetail.vue'
import SyozokuDetail from '@/components/koyoukeiyaku/parts/SyozokuDetail.vue'
import NyuusyaDateDetail from '@/components/koyoukeiyaku/parts/NyuusyaDateDetail.vue'
import JikyuuCalcDetail from '@/components/koyoukeiyaku/parts/JikyuuCalcDetail.vue'
import { useInit } from '@/composable/master/syounin_group/init';
import { numberFormat, timeToHHmm } from '@/filters/common';

export default defineComponent({
  props: {
    koyouKeiyakuId: {
      type: Number,
      require: true,
      default: null
    },
    viewMode: { // 社員マスタから呼ぶときはviewMode trueを渡す（pages/Detail.vueからはpropsでviewModeは渡さず、ここでdefault:falseとする）
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { setKoyouKeiyakuTemplate, sheetTitle, options, getAllKoyouKeiyakuOption, getOptionsLabel, judgeHoninSyounin, canHonninSyounin, judgeDelete, canDelete, getYoubiLabel } = useKoyouKeiyakuInit()
    const { keiyakuDetail, getKeiyakuDetail, calcSalary, calcKihonkyuu } = useKoyouKeiyakuDetail()
    const { allBukaOptions, getAllBukaOptions } = useMstBukaInit();
    const { submit, approval, honninSyounin, readDeniedMessage } = useApproval();
    const { confirmDelete } = useDelete();
    const { getSyouninFlow, syouninFlow } = useInit()

    const { fileDownload, fileOpenNewTab, thumbBaseUrl } = useFileDownload()
    const keiyakuId: Ref<number | null> = ref(null);

    const isInit = ref(false)

    const authStore = useAuthStore();
    const loginUserId = authStore.user?.user_id;
    const router = useRouter();

    // 定型文
    const message = Message;

    // 値が取得できなかった場合に表示する文字列
    const undefinedLabel: String = '-';

    // 本人ステータス種別の更新したい値を保持（keiyakuDataに影響させない為）
    const honninStatusType: Ref<number | null> = ref(null);

    // TODO: デバッグ用
    const showDebugData = ref(false)

    onMounted(async () => {
      if (!props.koyouKeiyakuId) {
        await DialogService.error({
          title: '雇用契約IDが指定されていません',
          text: '検索画面より改めて目的の雇用契約を選択してください'
        }).then(() => {
          router.push(RouterConst.KOYOUKEIYAKU_SEARCH)
        })
        await failedGetKoyouKeiyaku()
      }

      keiyakuId.value = props.koyouKeiyakuId
      await loadKoyouKeiyaku()
    })

    const failedGetKoyouKeiyaku = async () => {
      await DialogService.error({
        title: '雇用契約の取得に失敗しました',
        text: '検索画面より改めて目的の雇用契約を選択してください'
      }).then(() => {
        router.push(RouterConst.KOYOUKEIYAKU_SEARCH)
      })
    }

    // 雇用契約関連の情報読み込み
    // ※再読み込みなどもこれを使ってください
    const loadKoyouKeiyaku = async () => {
      isInit.value = false
      if (!keiyakuId.value) {
        await failedGetKoyouKeiyaku()
        return
      }

      await getAllKoyouKeiyakuOption()
      await getAllBukaOptions();

      if (!options.value) {
        // ひとまずreturnはせずに続行可能にしておく
        await DialogService.error({
          title: 'オプション値の取得に失敗しました',
          text: '必要な情報の閲覧に支障がある場合やエラーが発生した場合は再度開き直してください'
        })
      }

      if (!allBukaOptions.value) {
        // ひとまずreturnはせずに続行可能にしておく
        await DialogService.error({
          title: '部課情報の取得に失敗しました',
          text: '必要な情報の閲覧に支障がある場合やエラーが発生した場合は再度開き直してください'
        })
      }

      await getKeiyakuDetail(keiyakuId.value)
      if (keiyakuDetail.value) {
        await setKoyouKeiyakuTemplate(keiyakuDetail.value)
        // 提出済みの場合は承認フローを取得する
        if (keiyakuDetail.value.eigyou_user_id) {
          await getSyouninFlow(keiyakuId.value, OptionConst.SYOUNIN_FLOW_TYPES.KOYOUKEIYAKU, keiyakuDetail.value.eigyou_user_id)
        }
        await judgeHoninSyounin(keiyakuDetail.value, syouninFlow.value)
        await judgeDelete(keiyakuDetail.value)
        honninStatusType.value = cloneDeep(keiyakuDetail.value.honnin_status_type)
      } else {
        await failedGetKoyouKeiyaku()
        return
      }
      isInit.value = true
    }

    // この契約書を元に新規作成するボタン
    const createFrom = () => {
      if (!keiyakuDetail.value) {
        return
      }

      router.push({
        name: RouterConst.KOYOUKEIYAKU_EDIT,
        query: {
          id: keiyakuDetail.value.koyou_keiyaku_id,
          mode: OptionConst.KOYOUKEIYAKU_EDIT_MODE.FROM
        },
      })
    }

    // 編集するボタン
    const edit = () => {
      if (!keiyakuDetail.value) {
        return
      }
      router.push({
        name: RouterConst.KOYOUKEIYAKU_EDIT,
        query: {
          id: keiyakuDetail.value.koyou_keiyaku_id,
          mode: OptionConst.KOYOUKEIYAKU_EDIT_MODE.EDIT
        },
      })
    }

    // ダウンロードボタンクリック
    const { downLoad } = usePrint();

    const download = (id: number | null) => {
      if (id === null) {
        return;
      }

      DialogService.question({
        text: '雇用契約書をダウンロードしますか？',
        showCancelButton: true,
        confirmButtonText: 'ダウンロードします',
        cancelButtonText: 'キャンセル',
      }).then((result: SweetAlertResult) => {
        if (result.isConfirmed) {
          // 別タブで開く
          window.open(downLoad(id), '_blank');
        }
      });
    }

    // 提出ボタン
    const submitOn = async () => {
      if (!keiyakuId.value) {
        return
      }

      await DialogService.question({
        title: '雇用契約を提出しますか？',
        text: '担当営業者の承認グループに提出され、提出後は編集できなくなります',
        showCancelButton: true,
        confirmButtonText: '提出します',
        cancelButtonText: 'キャンセル',
      }).then(async (result: SweetAlertResult) => {
        if (!result.isConfirmed || !keiyakuId.value) {
          return
        }

        const res = await submit(keiyakuId.value)
        if (!res) {
          await DialogService.error({
            title: '提出に失敗しました',
            text: '再度提出するか時間をおいてやりなおしてください'
          })
          return
        }

        await DialogService.info({
          text: `雇用契約書を提出しました。画面を再読み込みします。`
        }, true).then(async (result) => {
          if (result.isConfirmed) {
            if (!keiyakuId.value) {
              return
            }
            await loadKoyouKeiyaku()
          }
        });
      })
    }

    // 雇用契約書「否認理由を確認しました」ボタン
    const readMessage = async () => {
      const result = await DialogService.question({
        text: '否認理由を確認しましたか？',
        confirmButtonText: '確認しました',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      }
      ).then((result) => {
        if (!keiyakuDetail.value?.koyou_keiyaku_id || !keiyakuDetail.value.syounin_status_type) {
          return false
        }
        if (result.isConfirmed) {
          return readDeniedMessage(keiyakuDetail.value.koyou_keiyaku_id, keiyakuDetail.value.syounin_status_type);
        }
      })

      if (result) {
        await DialogService.info({
          text: '否認理由の確認処理を行いました。画面を再読み込みします。'
        }).then(async () => {
          await loadKoyouKeiyaku()
        })
      }
    }

    // 雇用契約書を削除ボタン
    const deleteKoyouKeiyaku = () => {
      if (!keiyakuId.value) {
        return
      }
      confirmDelete(keiyakuId.value);
    }

    // 社内承認
    const doApproval = async (status: number) => {
      if (!keiyakuDetail.value) {
        return
      }

      if (await approval(keiyakuDetail.value?.koyou_keiyaku_id, status)) {
        await DialogService.info({
          text: `承認結果を送信しました。画面を再読み込みします。`
        }, true).then(async (result) => {
          if (result.isConfirmed) {
            if (!keiyakuId.value) {
              return
            }
            await loadKoyouKeiyaku()
          }
        });
      }
    }

    // 社内承認（確認のみ）
    const doCheck = async () => {
      if (!keiyakuDetail.value) {
        return
      }

      if (await approval(keiyakuDetail.value?.koyou_keiyaku_id, OptionConst.SYOUNIN_STATUS.APPROVED)) {
        await DialogService.info({
          text: `確認済みにしました。画面を再読み込みします。`
        })
        await loadKoyouKeiyaku()
      }
    }

    // 本人承認
    const doHonninSyounin = async () => {
      if (!keiyakuId.value || !keiyakuDetail.value) {
        return
      }

      if (!honninStatusType.value) {
        DialogService.error({
          text: '本人承認状況を選択してください'
        })
        return
      }

      const label = options.value?.honnin_status_type.find((opt) => opt.val === honninStatusType.value)?.label

      if (!label) {
        return
      }

      if (await honninSyounin(keiyakuId.value, honninStatusType.value, label, keiyakuDetail.value.shinsei_type)) {
        await DialogService.info({
          text: `本人承認状況を送信しました。画面を再読み込みします。`
        }, true).then(async (result) => {
          if (result.isConfirmed) {
            if (!keiyakuId.value) {
              return
            }
            await loadKoyouKeiyaku()
          }
        });
      }
    }

    return {
      message,
      calcSalary,
      calcKihonkyuu,
      getOptionsLabel,
      download,
      createFrom,
      edit,
      submitOn,
      RouterConst,
      timeToHHmm,
      syouninFlow,
      doApproval,
      doCheck,
      loginUserId,
      doHonninSyounin,
      honninStatusType,
      readMessage,
      deleteKoyouKeiyaku,
      options,
      sheetTitle,
      isInit,
      keiyakuDetail,
      OptionConst,
      allBukaOptions,
      undefinedLabel,
      canHonninSyounin,
      canDelete,
      showDebugData,
      authStore,
      PermissionConst,
      fileDownload,
      fileOpenNewTab,
      thumbBaseUrl,
      numberFormat,
      getYoubiLabel
    }
  },
  components: {
    'syozoku-detail': SyozokuDetail,
    'koyoukeiyaku-files': KoyouKeiyakuFiles,
    'koyou-type-detail': KoyouTypeDetail,
    'keitai-type-detail': KeitaiTypeDetail,
    'shinsei-type-detail': ShinseiTypeDetail,
    'keiyaku-koushin-type-detail': KeiyakuKoushinTypeDetail,
    'nyuusya-date-detail': NyuusyaDateDetail,
    'jikyuu-calc-detail': JikyuuCalcDetail,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';
@import '@scss/components/koyoukeiyaku-work_times.scss';
</style>
